import React from 'react'
import styled from 'styled-components'
import Panel from '../../components/Panel'
import SummativePracticalAssessmentTask
  from './SummativePracticalAssessmentTask'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const ScrollingDiv = styled.div`
  overflow-y: auto;
`

export default function UnitElementsBySections({
  summativePracticalAssessments,
  children,
}) {
  return (
    <Panel
      header="Unit Elements & Order"
      style={{ width: '100%', height: '100%' }}
      contentStyle={{
        height: 'calc(100% - 3em)',
        position: 'relative',
        boxSizing: 'border-box',
      }}>
      <Content>
        <div>
          {children}
        </div>
        <ScrollingDiv>
          {summativePracticalAssessments.map(
            ({ name, tasks, introduction }, i) => (
              <SummativePracticalAssessmentTask
                key={i}
                name={name}
                tasks={tasks}
                introduction={introduction}
              />
            ),
          )}
        </ScrollingDiv>
      </Content>
    </Panel>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/SummativePracticalAssessmentTasks.js